import { render, staticRenderFns } from "./AlertFiscalData.vue?vue&type=template&id=0962319e&"
import script from "./AlertFiscalData.vue?vue&type=script&lang=js&"
export * from "./AlertFiscalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports